import { LogoutRounded as LogoutRoundedIcon } from '@mui/icons-material'
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material'
import { t } from 'i18next'
import { useNavigate } from 'react-router-dom'

import { useAuth } from '../../Shared/Contexts/AuthContext.jsx'
import { useGlobalContext } from '../../Shared/Contexts/GlobalContext.jsx'

export default function ProfileMenu({ anchorEl, isOpen, handleClose }) {
  const { openSuccessAlert } = useGlobalContext()
  const navigate = useNavigate()

  const {
    authState: { refreshToken },
    logout
  } = useAuth()

  const { useLogoutUser } = useAuth()

  const handleLogout = () => {
    useLogoutUser({ refreshToken })
      .then(() => {
        openSuccessAlert()
        logout()
      })
      .catch(() => logout())
      .finally(() => navigate('/'))
  }

  return (
    <Menu
      anchorEl={anchorEl}
      open={isOpen}
      onClose={handleClose}
      onClick={handleClose}
      transformOrigin={{
        horizontal: 'right',
        vertical: 'top'
      }}
      anchorOrigin={{
        horizontal: 'right',
        vertical: 'bottom'
      }}
      sx={{ top: '20px' }}>
      <MenuItem
        id="profile-menu-logout"
        onClick={handleLogout}>
        <ListItemIcon>
          <LogoutRoundedIcon />
        </ListItemIcon>
        <ListItemText>{t('common.logout')}</ListItemText>
      </MenuItem>
    </Menu>
  )
}
